import { fromJS } from 'immutable';
import { endLoad, startLoad } from 'portaltransparencia-common/crud/Core.js';

import * as types from './Types.js';

const initialState = fromJS({
  cargos: {},
  cargosOxy: [],
  faixas: [],
  filtroCargos: [],
  filtroQuadros: [],
  filtroGrupos: [],
  filtroNiveis: [],
  funcoesGratificadas: [],
  filtroPlanoSalarial: [],
  cargoSelecionado: {}
});

function CargoReducer(state = initialState, action) {
  switch (action.type) {
    case types.LIST_CARGOS_START:
    case types.LIST_FAIXAS_START:
    case types.FILTRO_CARGOS_START:
    case types.FILTRO_QUADROS_START:
    case types.FILTRO_GRUPOS_START:
    case types.FILTRO_NIVEIS_START:
    case types.LIST_FUNCOES_GRATIFICADAS_START:
    case types.FILTRO_PLANOS_SALARIAIS_START:
    case types.LIST_PLANOS_SALARIAIS_START:
    case types.LIST_CARGOS_OXY_START:
    case types.LIST_MATRIZ_VIGENTE_START: {
      return startLoad(state);
    }

    case types.LIST_CARGOS_ERROR:
    case types.LIST_FAIXAS_ERROR:
    case types.FILTRO_CARGOS_ERROR:
    case types.FILTRO_QUADROS_ERROR:
    case types.FILTRO_GRUPOS_ERROR:
    case types.FILTRO_NIVEIS_ERROR:
    case types.LIST_FUNCOES_GRATIFICADAS_ERROR:
    case types.FILTRO_PLANOS_SALARIAIS_ERROR:
    case types.LIST_PLANOS_SALARIAIS_ERROR:
    case types.LIST_CARGOS_OXY_ERROR:
    case types.LIST_MATRIZ_VIGENTE_ERROR: {
      return endLoad(state);
    }

    case types.LIST_CARGOS_SUCCESS: {
      return endLoad(state.set('cargos', fromJS(action.payload)));
    }
    case types.LIST_FAIXAS_SUCCESS: {
      return endLoad(state.set('faixas', fromJS(action.payload)));
    }
    case types.FILTRO_CARGOS_SUCCESS: {
      return endLoad(state.set('filtroCargos', fromJS(action.payload)));
    }
    case types.FILTRO_QUADROS_SUCCESS: {
      return endLoad(state.set('filtroQuadros', fromJS(action.payload)));
    }
    case types.FILTRO_GRUPOS_SUCCESS: {
      return endLoad(state.set('filtroGrupos', fromJS(action.payload)));
    }
    case types.FILTRO_NIVEIS_SUCCESS: {
      return endLoad(state.set('filtroNiveis', fromJS(action.payload)));
    }
    case types.LIST_FUNCOES_GRATIFICADAS_SUCCESS: {
      return endLoad(state.set('funcoesGratificadas', fromJS(action.payload)));
    }
    case types.FILTRO_PLANOS_SALARIAIS_SUCCESS: {
      return endLoad(
        state.set('filtroPlanosSalariais', fromJS(action.payload))
      );
    }
    case types.LIST_PLANOS_SALARIAIS_SUCCESS: {
      return endLoad(state.set('planosSalariais', fromJS(action.payload)));
    }
    case types.LIST_CARGOS_OXY_SUCCESS: {
      const cargos = fromJS(
        action.payload.map(item => {
          return {
            ...item,
            open: false,
            visible: item.nivel === 1
          };
        })
      );

      return endLoad(
        state.set('cargosOxy', cargos).set('cargoSelecionado', cargos.get(0))
      );
    }
    case types.EXPAND_CARGO: {
      const cargos = state.get('cargosOxy').map(item => {
        if (
          item.get('id') === action.payload.id &&
          item.get('planoSalarialEstruturaId') == action.payload.estrutura &&
          item.get('planoSalarialId') == action.payload.plano
        ) {
          return item.set('open', true).set('visible', true);
        } else if (
          action.payload.nivel == 1 &&
          item.get('id') &&
          item.get('id') == action.payload.id &&
          item.get('nivel') ===
            nextLevel(state.get('cargosOxy'), action.payload)
        ) {
          return item.set('visible', true);
        } else if (
          action.payload.nivel == 2 &&
          item.get('id') &&
          item.get('planoSalarialEstruturaId') &&
          item.get('id') == action.payload.id &&
          item.get('planoSalarialEstruturaId') == action.payload.estrutura &&
          item.get('nivel') ===
            nextLevel(state.get('cargosOxy'), action.payload)
        ) {
          return item.set('visible', true);
        }

        return item;
      });

      return state.set('cargosOxy', cargos);
    }
    case types.COLLAPSE_CARGO: {
      const cargos = state.get('cargosOxy').map(item => {
        if (
          action.payload.nivel === 1 &&
          item.get('id') &&
          item.get('id') == action.payload.id &&
          item.get('nivel') > action.payload.nivel
        ) {
          return item.set('open', false).set('visible', false);
        } else if (
          action.payload.nivel === 2 &&
          item.get('id') &&
          item.get('planoSalarialEstruturaId') &&
          item.get('id') == action.payload.id &&
          item.get('planoSalarialEstruturaId') == action.payload.estrutura &&
          item.get('nivel') > action.payload.nivel
        ) {
          return item.set('open', false).set('visible', false);
        } else if (
          action.payload.nivel === 3 &&
          item.get('id') &&
          item.get('planoSalarialEstruturaId') &&
          item.get('id') == action.payload.id &&
          item.get('planoSalarialEstruturaId') == action.payload.estrutura &&
          item.get('planoSalarialId') == action.payload.plano &&
          item.get('nivel') > action.payload.nivel
        ) {
          return item.set('open', false).set('visible', false);
        } else if (
          item.get('id') &&
          item.get('id') === action.payload.id &&
          item.get('planoSalarialEstruturaId') == action.payload.estrutura &&
          item.get('planoSalarialId') == action.payload.plano
        ) {
          return item.set('open', false).set('visible', true);
        }

        return item;
      });

      return state.set('cargosOxy', cargos);
    }
    case types.LIST_MATRIZ_VIGENTE_SUCCESS: {
      return endLoad(state.set('matrizesVigentes', fromJS(action.payload)));
    }
  }

  return state;
}

function nextLevel(list, item) {
  const index = list.findIndex(i => i.get('codigo') === item.codigo);

  const proximoNivel = list.getIn([index + 1, 'nivel']);

  return proximoNivel;
}

export default CargoReducer;
